import axios from 'axios';

import { EventsApiRegistrationRequest } from './types';

const api = axios.create({
  baseURL: '/events-admin/api',
});

export const EventsApi = {
  registration(data: EventsApiRegistrationRequest) {
    return api.post('/members/receiver', data);
  },
};
